import { Link, useRouteError } from "react-router-dom";
import p from "./Pagina.module.css";

export default function NoEncontrado() {
  const error = useRouteError();
  const esRuta = !error || error?.status === 404;

  return (
    <div className={`container ${p.centrado}`}>
      <span className={p.codigoError}>{esRuta ? "404" : "500"}</span>

      <h1>{esRuta ? "Pagina no encontrada" : "Algo salio mal"}</h1>

      <p className={p.tarjetaTexto}>
        {esRuta
          ? "El enlace que seguiste no existe o cambio de direccion."
          : "Ocurrio un error inesperado al cargar esta seccion. Vuelve a intentarlo en un momento."}
      </p>

      {!esRuta && error?.message && (
        <p className="hint mono">{String(error.message)}</p>
      )}

      <div className={p.acciones}>
        <Link to="/" className="btn btn--accent">
          Ir al inicio
        </Link>
        <Link to="/productos" className="btn btn--ghost">
          Ver catalogo
        </Link>
      </div>
    </div>
  );
}
